import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const Gallery = () => {
  return (
    <section className="gallery">
      <div>
        <StaticImage
          src="../assets/images/gallery/MY20_Talon_29_gallery01.jpg"
          alt="bicycle"
          className="gallery-img"
          placeholder="tracedSVG"
        />
      </div>
      <div>
        <StaticImage
          src="../assets/images/gallery/MY20_Talon_29_gallery02.jpg"
          alt="bicycle"
          className="gallery-img"
          placeholder="tracedSVG"
        />
      </div>
      <div>
        <StaticImage
          src="../assets/images/gallery/MY20_Talon_29_gallery03.jpg"
          alt="bicycle"
          className="gallery-img"
          placeholder="tracedSVG"
        />
      </div>
      <div>
        <StaticImage
          src="../assets/images/gallery/MY20_Talon_29_gallery04.jpg"
          alt="bicycle"
          className="gallery-img"
          placeholder="tracedSVG"
        />
      </div>
      <div>
        <StaticImage
          src="../assets/images/gallery/MY20_Talon_29_gallery05.jpg"
          alt="bicycle"
          className="gallery-img"
          placeholder="tracedSVG"
        />
      </div>
      <div>
        <StaticImage
          src="../assets/images/gallery/MY20_Talon_29_gallery05.jpg"
          alt="bicycle"
          className="gallery-img"
          placeholder="tracedSVG"
        />
      </div>
      <div>
        <StaticImage
          src="../assets/images/gallery/MY20_Talon_29_gallery07.jpg"
          alt="bicycle"
          className="gallery-img"
          placeholder="tracedSVG"
        />
      </div>
      <div>
        <StaticImage
          src="../assets/images/gallery/MY20_Talon_29_gallery08.jpg"
          alt="bicycle"
          className="gallery-img"
          placeholder="tracedSVG"
        />
      </div>
    </section>
  )
}

export default Gallery
